import {Component, OnInit, Input, ViewChild, ElementRef, OnChanges, SimpleChanges} from '@angular/core';
import { AceEditorComponent } from 'ng2-ace-editor';
import {LeftpanelComponent} from '../../../../leftpanel/leftpanel.component';


@Component({
  selector: 'code-viewer',
  templateUrl: './code-viewer.component.html',
  styleUrls: ['./code-viewer.component.scss']
})
export class CodeViewerComponent implements OnInit {
  @Input() language = 'javascript';
  @Input() code = '';
  @Input() response = false;

  editorOptions = {
    theme: 'monokai',
    maxLines: Infinity,
    printMargin: false,
    useWorker: false,
    showGutter: true,
    foldStyle: 'markbegin'
  };
  @ViewChild('editor') editor: AceEditorComponent;

  constructor(private platform: LeftpanelComponent) {}

  ngOnInit(): void {
  }
  getContent() {
    return this.editor.getEditor().getValue();
  }
  copyToClipboard() {
    const textToCopy = this.getContent();
    navigator.clipboard.writeText(textToCopy);
    this.platform.openSnackBar('Copied to clipboard.', 'Success', {
      duration: 2000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }
}
